// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M3 7.5H5.00368M3 12H5.00368M3 16.5H5.00368M7.5 20.9996V19.0322M12 20.9996V19.0322M16.5 20.9996V19.0322M3 3H11V13H21V21H3V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"measurement-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 3L11 3L11 13L21 13L21 21L3 21L3 3Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 7.5H5.00368M3 12H5.00368M3 16.5H5.00368M7.5 20.9996V19.0322M12 20.9996V19.0322M16.5 20.9996V19.0322M3 3H11V13H21V21H3V3Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Measurement1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'measurement-1',
    ref,
    icon: element,
  },
));

Measurement1Icon.displayName = 'Measurement1Icon';

export default Measurement1Icon;
